import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'space-between',
    marginTop: theme.spacing(1),
    backgroundColor: theme.palette.alert.background,
    padding: theme.spacing(2, 3.125),
    position: 'relative',

    '&:before': {
      content: '""',
      width: theme.spacing(0.5),
      backgroundColor: theme.palette.primary.main,
      position: 'absolute',
      height: '100%',
      top: 0,
      left: 0,
    },
  },

  title: {
    textAlign: 'center',
    fontFamily: '"Bebas Neue"',
    fontSize: theme.spacing(3),
    color: theme.palette.alert.text.primary,
    textTransform: 'uppercase',
  },

  break: {
    color: theme.palette.primary.light,
  },

  description: {
    textAlign: 'center',
    color: theme.palette.alert.text.secondary,
  },

  button: {
    textTransform: 'uppercase',
  },

  startingTimer: {
    minWidth: theme.spacing(18.25),
  },
}));
